/**************************************************
 * Nombre:       Detalle_Producto_Img_Caracteristicas_Img
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import {useEffect, useRef, useState} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import 'photoswipe/dist/photoswipe.css'
import Tarjeta_Img_Detalle from "../../Tarjetas/Tarjeta_Img_Detalle";
import {Splide, SplideSlide} from "@splidejs/react-splide";


const Detalle_Producto_Img_Caracteristicas_Img = ({producto, seleccionada}) => {
    const {sCell, masSM} = useResponsive()
    const [imgs, setImgs] = useState([])
    const refe = useRef()


    useEffect(() => {

        let arr = []
        if (producto.img) {
            arr.push(producto.img)
        }

        if (producto.imgs) {
            arr.push(...producto.imgs)
        }
        setImgs(arr)

    }, [producto]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            {sCell ?
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Splide
                        ref={refe}
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: false,
                            speed: 1000,
                            rewind: true,
                            perPage: 1,
                            arrows: false,
                            pagination: true,
                            width: '100%',
                            drag: 'false',
                            interval: 1000,
                            noDrag: true,
                            type: 'loop',
                            gap: 10,
                            padding: 30
                        }}
                    >

                        {imgs.map((srcImg, index) => {
                            return (
                                <SplideSlide>
                                    <Tarjeta_Img_Detalle img={srcImg} imgs={imgs}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>

                :
                imgs.map((img, index) => (
                    <Grid key={index + '9w6'} container size={{xs: 12, sm: 12, md: 6}}
                          sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Img_Detalle img={img} imgs={imgs}/>
                    </Grid>
                ))

            }


        </Grid>
    )

}
export default Detalle_Producto_Img_Caracteristicas_Img

